// extracted by mini-css-extract-plugin
export default {"logout-button":"avartar_logout-button__pKITL","logout-header":"avartar_logout-header__swpww"};